import { render, staticRenderFns } from "./dataUpload.vue?vue&type=template&id=67378287&scoped=true"
import script from "./dataUpload.vue?vue&type=script&lang=js"
export * from "./dataUpload.vue?vue&type=script&lang=js"
import style0 from "./dataUpload.vue?vue&type=style&index=0&id=67378287&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67378287",
  null
  
)

export default component.exports